import {isSameOrder, PlacedOrder, PlacedOrders} from "../models/PlacedOrder";
import {isAddChange, isRefreshChange, PlacedOrdersChange} from "./PlacedOrdersChange";
import {ArrayUtil} from "../../../../js/util/ArrayUtil";

export function applyChange(current: PlacedOrders, change: PlacedOrdersChange): PlacedOrders {
    if (isRefreshChange(change)) {
        return change.orders;
    } else if (isAddChange(change)) {
        return applyAddChange(current, change.order);
    } else {
        return current;
    }
}

function applyAddChange(current: PlacedOrders, added: PlacedOrder): PlacedOrders {
    const updated = [...current, added];
    return ArrayUtil.distinct(updated, isSameOrder);
}
